export default __webpack_public_path__ + "static/media/printer.f2741f2f.svg";